import { Component, Input, OnDestroy } from '@angular/core';
import {BzgModalService} from 'bz-genome-angular';
import {EditBotComponent} from '../edit-bot/edit-bot.component'
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { getAutomationCurrentConnector } from '../store/selectors/rpa-automation-anywhere-conn.selector';
import {
  GetAutomationAnywhereBots,
  GetAutomationAnywhereDevices,
  GetAutomationAnywherePoolDevices,
  GetAutomationAnywhereUsers,
  ResetDeviceBotSelection
} from '../store/actions/rpa-automation-anywhere-conn.actions';
import { IAppState } from 'app/IAppState';
import { IRPAAutomationAnywhereBots, IRpaConnectionAutomationAnywhere } from 'app/rpa-bots/core/IRpaBots';

@Component({
    selector: 'bot-processes-aae',
    templateUrl: 'bot-processes-aae.component.html',
    styleUrls: ['bot-processes-aae.component.scss']
})
export class BotProcessesAaeComponent implements OnDestroy{
    @Input() title;
    @Input() bots;
    @Input() queues;
    @Input() version;
    public editBotVisible: boolean;
    private automationAnywhereConnection$: Observable<IRpaConnectionAutomationAnywhere>;
    private automationAnywhereConnSub: any;
    private listTimeOut: any[] = [];
    private connection: IRpaConnectionAutomationAnywhere;

    constructor( private _modalService: BzgModalService,private _store: Store<IAppState>){
      this.automationAnywhereConnection$ = this._store.pipe(select(getAutomationCurrentConnector));
      this.automationAnywhereConnSub = this.automationAnywhereConnection$.subscribe((conn:IRpaConnectionAutomationAnywhere)=>{
        this.connection = conn;
        if(this.connection.password && this.connection.server){
          if (this.connection.version && this.connection.version.startsWith("11.3")){
            this.listTimeOut.push(setTimeout(()=>this._store.dispatch(new GetAutomationAnywhereBots(conn)),500));
            this.listTimeOut.push(setTimeout(()=>this._store.dispatch(new GetAutomationAnywhereDevices(conn)),500));
          }
          else{
            this.listTimeOut.push(setTimeout(()=>this._store.dispatch(new GetAutomationAnywherePoolDevices(conn)),500));
            this.listTimeOut.push(setTimeout(()=>this._store.dispatch(new GetAutomationAnywhereUsers(conn)),500));
          }
        }
      });
    }

    openEditBot(process: IRPAAutomationAnywhereBots) {
      if (this.connection && this.connection.password && this.connection.server) {
        this._modalService.open(EditBotComponent, {
          closeOnBackdropClick: false,
          closeOnRouterNavigation: true,
          closeOnEscape: false,
          maxHeight:'850px',
          height:'800px',
          data: {process, connection:this.connection}
        });
      }
    }

    ngOnDestroy(){
      this._store.dispatch(new ResetDeviceBotSelection())
      if(this.automationAnywhereConnSub){
        this.automationAnywhereConnSub.unsubscribe();
      }
      this.listTimeOut.forEach(timeOut => clearTimeout(timeOut));
    }

}
